module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/199f58b4a80fa56c5d8e032d6da5e9c2.svg";